<template>
    <v-row>
        <Loader v-if="loader"></Loader>
        <v-col cols="12">
            <v-card flat>
                <v-card-text>
                    <v-col class="mx-auto" cols="12" sm="6">
                        <v-form ref="form" v-on:submit.prevent="SaveCategory">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="name" hide-details
                                        label="نام دسته بندی" placeholder=" " dense outlined>
                                        <template #label>
                                            نام دسته بندی <span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete :items="type_items" :rules="[requireRule]" v-model="type"
                                        hide-details label="نوع دسته بندی" placeholder=" " dense outlined>
                                        <template #label>
                                            نوع دسته بندی<span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                 <v-col cols="12">
                                    <v-autocomplete :items="lang_items" :rules="[requireRule]" v-model="langSelected"
                                        hide-details label="انتخاب زبان" placeholder=" " dense outlined>
                                        <template #label>
                                            انتخاب زبان<span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col class="mt-3" cols="12">
                                     <BoxImages ref="fileManager" @uploadDone="getImgUrl" />
                                    <!-- @setImgUrl="getImgUrl" -->
                                    <v-btn @click="$refs.fileManager.dialog = true" width="100%" v-bind="attrs" v-on="on">
                                        انتخاب عکس
                                    </v-btn>
                                    <v-card>
                                        <v-img class="ma-3 text-center mx-auto" width="200" v-if="image" :src="$BaseUrl+image"></v-img>
                                    </v-card>
                                </v-col>
                                <!-- <v-col cols="12">
                                    <v-file-input v-model="imgPath2" :rules="category_id? '' :[requireRule]" label="عکس شاخص" outlined dense>
                                        <template #label>
                                         عکس هاور<span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-file-input>
                                    <v-img v-if="image2" :src="$BaseUrl+image2"></v-img>
                                </v-col> -->
                                <v-col cols="12">
                                    <v-btn width="100%" height="40" class="white--text" depressed color="#02c9b7"
                                        type="submit">ذخیره</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import BoxImages from '../../components/Images.vue'
    export default {
        props: ['category_id'],
        data() {
            return {
                name: '',
                loader: false,
                map: null,
                tileLayer: null,
                mapMarkers: [],
                imgPath: '',
                imgPath2: '',
                image:'',
                image1 : '',
                image2 : '',
                type_items: [{
                    text: 'وبلاگ',
                    value: 'blog'
                }, {
                    text: 'محصولات',
                    value: 'product'
                }, {
                    text: 'آشپزی',
                    value: 'cook'
                }],
                lang_items: [{
                    text: 'فارسی',
                    value: 'fa'
                }, {
                    text: 'انگلیسی',
                    value: 'en'
                }],
                langSelected:'fa',
                type: '',
                layers: [{
                    id: 0,
                    name: 'Requests',
                    active: true,
                    features: [],
                }, ],
            }
        },
        components: {
            BoxImages
        },
        created() {
            if (this.category_id) {
                this.getCategory()
            }
        },
        watch:{
            imgPath(){
                this.uploadImg(1)
            },
            imgPath2(){
                this.uploadImg(2)
            }
        },
        methods: {
            SaveCategory() {
                var valid = this.$refs.form.validate();
                if (!valid)
                    return;
                this.loader = true
                var method = ''
                var url = ''
                if (this.category_id) {
                    method = 'put'
                    url = '/admin/category/edit/' + this.category_id
                } else {
                    method = 'post'
                    url = '/admin/category/add'
                }
                this.request({
                        method: method,
                        url: url,
                        data: {
                            name: this.name,
                            type: this.type,
                            image : this.image,
                            lang:this.langSelected
                        }
                    })
                    .then((response) => {
                        //this.$refs.form.reset();
                        this.$notify({
                            title: 'انجام شد',
                            text: 'با موفقیت انحام شد',
                            group: 'foo',
                            type: 'success',
                        });
                        this.$router.push({
                            name: 'list_category'
                        })
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getCategory() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/category/single/' + this.category_id,
                    })
                    .then((response) => {
                        this.name = response.data.name,
                        this.type = response.data.type
                        this.langSelected=response.data.lang
                        this.image = response.data.image
                    })
                    .catch(error => {})
                    .finally(x => {
                        this.loader = false
                    })
            },
            getImgUrl(e) {
                this.image = e
            },
            
        }
    }
</script>

<style>

</style>
